module.exports = "/assets/data/4bfedfc8bd6bf2744ee5c527b24a3e79-SG9.data.json";